import { useVolumePricingBadgeData } from '../../../product'
import { offerAccessorGetVolumePricing } from '../../model/offerAccessor/offerAccessorGetVolumePricing'
import { useProductPageContext } from '../productPageContext'

type UseGenerateVolumePricingBadgeDataProps = {
  discount?: number
  discountActivated?: boolean
  quantity?: number
}

export const useGenerateVolumePricingBadgeData =
  (): UseGenerateVolumePricingBadgeDataProps => {
    const {
      currentOffer,
      quantitySelectionControls: { quantity },
    } = useProductPageContext()

    const volumePrices = offerAccessorGetVolumePricing(currentOffer) ?? []

    return useVolumePricingBadgeData(quantity, volumePrices)
  }
